class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = this.closest(".site-header");
    this.classes = { itemActive: "f-menu__item-active" };
    this.header.timeoutEnter = null;
    this.header.timeoutLeave = null;
  }

  onToggle(evt) {
    const li = evt.target.closest(".f-site-nav__item");
    const isOpen = this.mainDetailsToggle.open;
    const isMega = li.classList.contains("f-site-nav__item--mega");

    clearTimeout(isOpen ? this.header.timeoutLeave : this.header.timeoutEnter);

    if (isOpen) {
      if (isMega) {
        this.header.calcDropdownHeight(li.querySelector(".f-site-nav__dropdown"));
        this.header.handleMegaItemActive();
        this.header.timeoutEnter = setTimeout(() => li.classList.add(this.classes.itemActive), 160);
      } else {
        li.classList.add(this.classes.itemActive);
      }
    } else {
      li.classList.remove(this.classes.itemActive);
      this.header.timeoutLeave = setTimeout(() => this.header.handleMegaItemDeactive(), 80);
    }

    if (this.header.headerSticky) {
      this.header.headerSticky.preventReveal = isOpen;
    }
  }
}

customElements.define("header-menu", HeaderMenu);

class SiteHeader extends HTMLElement {
  constructor() {
    super();
    this.classes = {
      active: "f-header__mega-active",
      headerScheme: this.dataset.headerColorScheme,
      dropdownScheme: this.dataset.dropdownColorScheme,
    };
    this.headerSticky = document.querySelector(".site-header__wrapper");
    this.isRTL = document.documentElement.getAttribute("dir") === "rtl";
  }

  connectedCallback() {
    this.querySelectorAll(".f-site-nav__sub-item--has-child").forEach(item => this.handleGrandLinksPosition(item));
  }

  calcDropdownHeight(dropdown) {
    const rect = dropdown.getBoundingClientRect();
    this.style.setProperty("--f-dropdown-height", rect.height + "px");
  }

  handleMegaItemActive() {
    this.classList.add(this.classes.active, this.classes.dropdownScheme);
    this.classList.remove(this.classes.headerScheme);
    document.documentElement.style.setProperty("--f-header-height", this.clientHeight + "px");
  }

  handleMegaItemDeactive() {
    this.classList.remove(this.classes.active, this.classes.dropdownScheme);
    this.classList.add(this.classes.headerScheme);
    document.documentElement.style.setProperty("--f-header-height", this.clientHeight + "px");
  }

  handleGrandLinksPosition(target) {
    const dropdownLV3 = target.querySelector(".f-site-nav__dropdown");
    if (dropdownLV3) {
      const rect = dropdownLV3.getBoundingClientRect();
      dropdownLV3.classList.toggle("f-site-nav__dropdown-reversed", !this.isRTL ? document.documentElement.clientWidth < rect.x + rect.width + 10 : rect.x < 10);
    }
  }
}

customElements.define("site-header", SiteHeader);

class SiteNav extends HTMLElement {
  constructor() {
    super();
    this.header = this.closest(".site-header");
    this.classes = { itemActive: "f-menu__item-active" };
    this.megaItems = this.querySelectorAll(".f-site-nav__item--mega");
    this.timeoutEnter = null;
    this.timeoutLeave = null;
  }

  connectedCallback() {
    if (this.header.classList.contains("show-dropdown-menu-on-hover")) {
      this.megaItems.forEach(megaItem => {
        megaItem.addEventListener("mouseenter", this.onMenuItemEnter.bind(this));
        megaItem.addEventListener("mouseleave", this.onMenuItemLeave.bind(this));
      });
    }
  }

  onMenuItemEnter(evt) {
    clearTimeout(this.timeoutLeave);
    const target = evt.target;
    const dropdown = target.querySelector(".f-site-nav__dropdown");

    if (dropdown) {
      this.header.calcDropdownHeight(dropdown);
      this.header.handleMegaItemActive();
      this.timeoutEnter = setTimeout(() => {
        target.classList.add(this.classes.itemActive);
      }, 160);
    }
  }

  onMenuItemLeave(evt) {
    const target = evt.target;
    clearTimeout(this.timeoutEnter);
    target.classList.remove(this.classes.itemActive);
    this.timeoutLeave = setTimeout(() => {
      this.header.handleMegaItemDeactive();
    }, 80);
  }

  closeMegaDropdowns() {
    clearTimeout(this.timeoutEnter);
    this.megaItems.forEach(megaItem => {
      megaItem.classList.remove(this.classes.itemActive);
    });
    this.timeoutLeave = setTimeout(() => {
      this.header.handleMegaItemDeactive();
    }, 80);
  }

  disconnectedCallback() {
    if (this.isHover) {
      this.megaItems.forEach(megaItem => {
        megaItem.removeEventListener("mouseenter", this.onMenuItemEnter.bind(this));
        megaItem.removeEventListener("mouseleave", this.onMenuItemLeave.bind(this));
      });
    }
  }
}

customElements.define("site-nav", SiteNav);
